import { render, staticRenderFns } from "./GI.vue?vue&type=template&id=d43bd11e&scoped=true"
import script from "./GI.vue?vue&type=script&lang=js"
export * from "./GI.vue?vue&type=script&lang=js"
import style0 from "./GI.vue?vue&type=style&index=0&id=d43bd11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43bd11e",
  null
  
)

export default component.exports